<template>
<div class="root">
  <div class="hecheng-tw">
    
    <div class="hecheng-content">
      <div class="dubbingSet">
        <div class="anchor_info">
            <div class="anchor_info_flex">
                <div class="anchorIcon"><img :src="defaultItem.imgurl" alt="主播头像"></div>
                    <div class="anchor_name">{{defaultItem.anchorName}}</div>
                    <div class="changeAnchor" @click="dialogTableVisible = true">更多</div>
                </div>
                <div class="readingSpeed">
                    <div class="speedText">语速</div>
                    <div class="speedAdjust">
                        <div class="speed_style">{{speedNum}}</div>
                        <el-slider class="el-slider slider" style="width:100%;"  v-model="speedNum">
                        </el-slider>
                        
                    </div>
                </div>
            </div>
        </div>

        <ul class="handle_tools">
          <div class="handle_list_video">

            <div  class="handle_item_video">
              <div class="handleitem_name">
                <i class="el-icon-video-camera-solid"></i>
                选择素材 
              </div>
              <div class="handleitem_options">
                <el-cascader-panel @change="setVideo"  v-model="conf.video_cats" size="mini" :options="video_cats"></el-cascader-panel>
              </div>
            </div>

            <div  class="handle_item_video">
              <div class="handleitem_name">
                <i class="el-icon-c-scale-to-original"></i>
                视频比例 
              </div>
              <div class="handleitem_options">
                <el-radio-group v-model="conf.cross" size="small">
                  <el-radio label="1" border>横屏(16:9)</el-radio>
                  <el-radio label="2" border disabled>竖屏(9:16)</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div  class="handle_item_video"> 
              <div class="handleitem_name">
                <i class="el-icon-chat-dot-square"></i>
                视频字幕 
              </div>
              <div class="handleitem_options">
                <el-radio-group v-model="conf.subtitles" size="small">
                  <el-radio label="1" border>不生成</el-radio>
                  <el-radio label="10" border>居中</el-radio>
                  <el-radio label="2" border>底部</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div  class="handle_item_video" :class="conf.subtitles==1 ? 'handle_item_video_no':''"> 
              <div class="handleitem_name">
                <i class="el-icon-edit"></i>
                字幕样式 
              </div>
              <div class="handleitem_options">
                <div class="f-color">
                  <span class="el-radio__label">文字颜色</span>
                  <el-color-picker :disabled="conf.subtitles==1" @change="subtitles_color" v-model="conf.font_color" size="small"></el-color-picker>
                </div>
                <div class="f-color">
                  <span class="el-radio__label">边框颜色</span>
                  <el-color-picker :disabled="conf.subtitles==1" @change="subtitles_color" v-model="conf.border_color" size="small"></el-color-picker>
                </div>
              </div>
            </div>

          </div>
        </ul>
        
      </div>

      <div class="line"></div>

      <el-row>
  

        <el-col :span="18">

          <div class="textArea" style="height: 640px;">
            
            <el-input
              type="textarea"
              placeholder="请输入推文内容..."
              v-model="textarea"
              :maxlength="max"
              show-word-limit          
              clearable
              style="height:100%"
              @input="changeinput($event)"
            >
            </el-input>
          </div>
          <div class="text_bottom">
            <div class="clear_text_video" @click="textarea=''">
              <img :src="require('../assets/images/cleartext.png')" alt="清空文本"> 清空文本 
            </div>        

          </div>

        </el-col>

        <el-col :span="6">
          <div class="demo-phone">
            <img :src="require('../assets/images/phone.png')" />
            <div v-if="conf.cross==1" class="cross" :style="{background:'url('+gif+')'}">
              <span>横屏(19:6)</span>
              <b v-if="conf.subtitles>1"
                :style="{color:conf.font_color,'-webkit-text-stroke':'0.5px '+ conf.border_color}"
               :class="'subtitles_'+conf.subtitles" class="subtitles">视频字幕示例</b>
            </d
            <div v-else="!conf.cross" class="vertical"></div>
          </div>
        </el-col>

      </el-row>

      <div class="line" style="margin-top: 10px;"></div>

      <div  class="dubbingAction">
        <div  class="prePlayAudio" @click="make(true)">
            <img v-if="!bofang" :src="require('../assets/images/playbnt.png')" alt="播放">
            <img v-else :src="require('../assets/images/paurse-2.png')" alt="暂停">
            
            <div class="play_title"> 
              点击按钮即可<span  style="color: rgb(41, 131, 253); margin-left: 0px;">试听</span>配音~ 
            </div>

            <div class="make_video_btn" @click.stop="makeVideo">
              <el-button type="primary">提交任务 <i class="el-icon-s-order"></i></el-button>
            </div>
            <div class="play_title"> 
              点击按钮即可<span  style="color: rgb(41, 131, 253); margin-left: 0px;">一键生成</span>推文视频，视频内容由线上热门视频素材剪辑生成
            </div>
        </div>

        

      <div  class="method_list">
        
        
      </div>
  </div>

</div>

<el-dialog :visible.sync="dialogTableVisible" @closed="stop" custom-class="aa">
  <div class="anchorbox">
    <div class="anchorbox_title">
      <span>主播列表</span>
    </div>  

    <div class="line"></div>

    <div class="zb_cats">
      <el-tabs value="tab_0">
        <el-tab-pane v-for="(item,i) of category" :key="i" :label="item.name" :name="'tab_'+i">
          <div class="nonMoodAnchors">

                <div v-for="(row,k) of data[item.id]" class="anchor" :class="{anchor_hover:anchor_index==k}" @click="anchor_hover(k,row)" >

                    <div  class="anchor-info">
                        <div  class="icon">
                            <img  :src="row.imgurl">
                        </div>
                        <div>
                            <div class="name"> {{row.anchorName}} </div>
                            <div class="character">{{ row.musicName }}</div>
                        </div>
                    </div>
                    
                    <div class="twoClickBtn">
                      <div>
                        <img @click.stop @click="play(row,$event)" alt="播放"
                        v-if="playId == row.id" :src="require('../assets/images/paurse.png')" />
                        <img @click.stop @click="play(row,$event)" alt="播放" v-else :src="require('../assets/images/bofanghui.png')" />
                      </div>
                                   
                    </div>
                </div>

          </div>
        </el-tab-pane>  
      </el-tabs>
    </div>



  </div>
</el-dialog>


<audio :src="mp3url" ref="audio" style="display:none;" @pause="pause()"> 
</audio>

<audio src="" ref="py" @pause="bf_pause()" style="display:none;" > 
</audio>


</div>

</template>
<style >

.handleitem_options .el-cascader-panel{
  height:120px;
}
.handleitem_options .el-cascader-menu__list{
  height:120px!important;
  overflow-y:scroll;
  min-height:10%!important;
}

.demo-phone{
  padding-top:20px;
  position:relative;
}
.demo-phone img{
  width:295px;
  height:626px;
}
.demo-phone .cross{
  background-color:#99a9bf;
  height:166px;
  width:284px;
  position:absolute;
  top:33%;
  left:6px;
  text-align:center;
  margin:0 auto;
}
.demo-phone .cross span{
  display:block;
  margin-top:68px;
  color:#fff;
  opacity: .4;
}
.subtitles{
  font-size:14px;
  font-family:"微软雅黑";
  //color:#fff;
}
.subtitles_2{
  position:relative;
  bottom:-34px;
}
.f-color{
  font-size:14px;
    margin-top:15px;
}
.f-color span{
  padding-top:5px;
}
.f-color .el-color-picker{
  vertical-align: middle;
  margin-left:5px;
}

.make_video_btn {
  margin:0 10px;
}


.twoClickBtn img{
  widht:24px;
  height:24px;
}

.aa{
  height:500px;
}

.aa .el-dialog__header {
    padding: 0px 1.33333vw 0px !important;
}

.aa .el-dialog__body {
  padding:0px !important;
}

.anchorbox{
  display:block;
}
.anchorbox_title {
    height: 2.66667vw;
    display: flex;
    align-items: center;
}
.anchorbox_title span {
    width: 5vw;
    margin-left: 3%;
    font-size: 1vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666;  
}

.zb_cats {
    
    width: 94%;
    margin-left: 3%;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.zb_cats .el-row {
  margin-bottom:1.33333vw
}
.zb_cats .el-row:last-child {
  margin-bottom:0
}
.zb_cats .type .el-col {
  border-radius:0.26667vw
}
.zb_cats .type .grid-content {
  border-radius:0.66667vw;
  min-height:2.4vw;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-bottom:1.33333vw;
  border:1px solid #fff
}
.zb_cats .el-tabs__item {
  font-size:14px!important;
  font-family:PingFang SC;
  font-weight:500;
  color:#333;
}
.zb_cats .is-active{
  color:#2983fd;
}
.zb_cats .selectedAnchorType .el-col {
  border-radius:0.26667vw
}
.zb_cats .selectedAnchorType .grid-content {
  border-radius:0.66667vw;
  min-height:2.4vw;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-bottom:1.33333vw;
  border:1px solid #2983fd
}
.zb_cats .selectedAnchorType .grid-content span {
  font-size:0.93333vw;
  font-family:PingFang SC;
  font-weight:bold;
  color:#2983fd
}

.nonMoodAnchors{
  
    overflow: auto;
    max-height:400px;
    overflow-y: scroll;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.anchor{
    width: 20vw;
    padding: 0 1.33333vw;
    height: 4.66667vw;
    background: linear-gradient(0deg, #ffffff 0%, #ffffff 100%);
    border: 1px solid #eaeaea;
    box-shadow: 0px 0.13333vw 0.33333vw 0px rgba(223,223,223,.23);
    border-radius: 0.53333vw;
    margin-left: .8%;
    margin-bottom: 1vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.anchor:hover{
      border: 1px solid #2983fd;
          background: #f5f9ff;
}
.anchor-info {
    display: flex;
    align-items: center;
}
.anchor-info .icon {
    width: 2.93333vw;
    height: 2.93333vw;
    border-radius: 50%;
    position: relative;
}
.anchor-info .icon img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.dubbingAction{
    height: 6.86667vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 94%;
    margin-left: 3%;
}
.prePlayAudio {
    display: flex;
    align-items: center;
}
.prePlayAudio img {
    width: 3.93333vw;
    height: 3.86667vw;
    cursor: pointer;
}
.play_title {
    background: #fff;
    border: 1px solid #f4f4f4;
    box-shadow: 0px 1px 1.26667vw 0.13333vw rgba(244,244,244,.77);
    border-radius: 0.4vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.86667vw;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333;
    padding: 0.66667vw 0.4vw;
    flex-wrap: nowrap;
}
.method_list {
    display: flex;
}
.method_item {
    text-align: center;
    position: relative;
    width: 5.33333vw;
    cursor: pointer;
}
.method_list img {
    width: 2.93333vw;
    height: 2.93333vw;
}
.method_list .method_name {
    font-size: 0.73333vw;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333;
    margin-top: -0.26667vw;
}
.method_list .viplable {
    position: absolute;
    width: 1.73333vw;
    height: 1.06667vw;
    left: 0.66667vw;
    top: -0.13333vw;
}


.root{
  background: #f2f3f5;
  padding:16px 0;
}
.hecheng-tw{
  width:82%;
  background:#fff;

  border:2px solid rgba(237,237,237,1);
  border-radius:10px;
  margin: 0px auto;
}
.line{ 
    margin: 0px 3.2% 0px .76%;
    height: 1px;
    background: #f4f4f4;
}



.step{
  width: 400px;
  height: 20px;
}
.imgtag{
    height: 22px;
    line-height: 22px;
    font-size: 12px;
    color: #fff;
    background: #1080FF;
    width: 72px;
    text-align: center;
    cursor: pointer;
}

.hecheng-content{
  display:flex;
  padding:10px;
}

.dubbingSet{
    display: flex;
    align-items: center;
    padding: 1.6vw 2.13333vw;
    height: 100%;
}

.anchor_info{
    width: 14.4vw;
    height: 5.46667vw;
    background: #f5f9ff;
    border-radius: 0.53333vw;
    padding: 1.06667vw 1.33333vw;
}
.anchor_info_flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.readingSpeed{
    display: flex;
    align-items: center;
    margin-top: 0.66667vw;
}
.anchorIcon{
    width: 3.06667vw;
    height: 3vw;
    border-radius: 50%;
}
.anchorIcon img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.anchor_name{
    font-size: 1.13333vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    margin-right: 2vw;
    width: 4vw;
}
.changeAnchor{
    width: 4.46667vw;
    height: 2vw;
    background: #2983fd;
    border: 1px solid #2983fd;
    border-radius: 1vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.86667vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
}
.anchor_hover{
  border: 1px solid #2983fd;
}
.readingSpeed{
    display: flex;
    align-items: center;
    margin-top: 0.66667vw;
}
.speedText{
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    width: 2vw;
}
.speedAdjust{
    display: flex;
    align-items: center;
    width: 11.2vw;
    border-radius: 0.13333vw;
    margin-left: 0.66667vw;
    position: relative;
}
.speedAdjust .slider {
    background: #f5f9ff;
}
.speed_style {
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2983fd;
    position: absolute;
    display: flex;
    justify-content: center;
    width: 100%;
    top: -0.93333vw;
}

.handle_list_video{
  display:flex;
  //flex-wrap: wrap;
  margin-left: 30px;
}
.handle_item_video{
    width: 100%;
    text-align: center;
    padding: 10px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color:#606266;
}
.handle_item_video_no{
  opacity: .5;
}
.handle_item_video:hover {
    background: #fafafa
}


.handle_item_video i{
    font-size:20px;
    vertical-align: middle;
    //margin-right:10px;
    color:#409EFF;
}
.handle_item_video .el-radio-group{
  display:flex;
  flex-direction: column;
  align-items: baseline
}
.handle_item_video label {
  margin-top:10px;
}
.handleitem_name{
  padding:10px 0;
}

.textArea{
    padding: 1.33333vw 2vw;
    padding-bottom: 0.66667vw;
}
.textArea textarea {
    height: 100%;
    width: 100%;
    border: 0;
    outline: none;
    resize: none;
    font-size: 1vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
}
.text_bottom {
    padding: 0 2vw;
    padding-bottom: 0.66667vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.clear_text_video{
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7d7d7d;
}
.clear_text_video img {
    width: 1.06667vw;
    height: 1.06667vw;
    margin-right: 0.33333vw;
}
.wordCount{
    font-size: 0.93333vw;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999;
}
.anchor-info .name{
    margin-top: 0.53333vw;
    height: 1.33333vw;
    font-size: 0.86667vw;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333;
    margin-left: 1.2vw;
    display: flex;
    align-items: center;
}
.anchor-info .character {
    margin-top: 0.26667vw;
    height: 1.2vw;
    font-size: 0.66667vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999;
    margin-left: 1.2vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
 
}


</style>
<script>
import { Message } from 'element-ui';


export default {
  data(){
    return{
      activeIndex:"6",
      speedNum:50,
      dialogTableVisible:false,
      category:[],
      data:[],
      mp3url:"",
      anchor_index:-1,
      defaultItem:{},
      isPlay: false,
      playId:0,
      wordsNum:0,
      textarea:"",
      max:5000,
      peiyin:"",
      cg:true,
      sign:"",
      bofang:false,
      gif:"https://app.huangque888.com/upload/imagesv_cat_gif_5.gif",
      bgmap:{},
      video_cats:[
      ],
      conf:{
        cross:"1",
        subtitles:"1",
        font_color:"#FFFFFF",
        border_color:"#000000",
        video_cats:[]
      }
    }
  },
  created () {
    
  },
  mounted() {
     this.getData();
     this.getCategory();
     this.getVideoCats();

     this.$store.commit("setActiveIndex",this.activeIndex)
     
  },
  methods:{
    tips(){
      this.tip("敬请期待!")
    },
    tip(text){
      Message.warning({
        type:"warning",
        message:text,
        center:true,
        duration:1500
      })
    },
    setVideo(v,a){
      this.gif = this.bgmap[v[0]]
    },
    getVideoCats(){
      this.axios({
        method: "post",
        url: "/api/tts/material_cats",
        data: {
        },
      }).then((res) => {
        if(res.data.code==200){
          let cat = [];
          Object.keys(res.data.data).forEach((index) => {
            cat.push({label:res.data.data[index],value:index})
            this.bgmap[index]="https://app.huangque888.com/upload/imagesv_cat_gif_"+index+".gif"
          })
          this.video_cats = cat;
          console.log(cat)
        }
      })

    },
    //获取分类
    getCategory(){
      this.axios({
        method: "post",
        url: "/api/tts/cat_list",
        data: {},
      }).then((res) => {
        
          this.category=res.data.data.items;
          
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //所有数据
    getData() {
      this.axios({
        method: "post",
        url: "/api/tts/list_new",
        data: {},
      })
        .then((res) => {
          // console.log(res.data.items);
          
          let arr=res.data.data;
          var first = {};
          
          var map = {};
          
          for (var i = 0; i < arr.length; i++) {
            map[arr[i].id] = arr[i].list;

            for(var ai in arr[i].list){

              if(i == 0){
                first = arr[i].list[ai];
              }

              if(arr[i].list[ai].id == this.$route.query.id){
                  console.log("id="+this.$route.query.id)
                  this.defaultItem = arr[i].list[ai];
              }
            }

          }        
          
          this.data=map;
          
          
          if(Object.keys(this.defaultItem).length === 0){
            this.defaultItem = first;
          }
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    anchor_hover(i,item){
      this.anchor_index=i;
      this.defaultItem = item;
      this.dialogTableVisible = false;
      this.stop();
      this.cg = true;
    },
    play(item,e){

      if(this.isPlay){
        let plid = this.playId;
        this.stop();
        if(plid == item.id){
          console.log("stop")
          return;
        }
      }

      console.log("play "+item.id);
      
      this.mp3url = item.demoUrl;
      this.playId = item.id;
      console.log(this.mp3url)
      
      if(this.$refs.audio.readyState != 4){
        this.$refs.audio.oncanplay =()=>{
            this.playAdu();
        }
      }else{
        this.playAdu();
      }
      
    },
    stop(){
      this.$refs.audio.pause();
      this.isPlay = false;
      this.playId = 0;
    },
    pause(){
      this.isPlay = false;
      this.playId = 0;
    },
    playAdu(){
      this.isPlay = true;
      this.$refs.audio.play();
    },
    make(play,callback){
      if(!this.checkUser()){
        return;
      }
      if(this.textarea.length <= 0){
        this.$alert('请输入推文内容', '操作失败', {
          confirmButtonText: '确定'
          
        });
        return;
      }

      if(this.cg == false && this.peiyin.length > 0){
        if(typeof callback == 'function'){
            callback()
            return
        }
        if(this.bofang){
          this.$refs.py.pause();

        }else{
          this.$refs.py.play();
          this.bofang = true;
        }
        
        return;
      }

      const loading = this.$loading({
          lock: true,
          text: '努力生成中，请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      this.cg = false;

      this.axios({
        method: "post",
        url: "/api/tts/make",
        data: {
          "text":this.textarea,
          "anchor":this.defaultItem.id,
          "speed":this.speedNum
        },
      }).then((res) => {
        loading.close();

        if(res.data.code == 200){
          this.peiyin = res.data.data.content
          this.sign = res.data.data.sign
          this.$refs.py.src = "data:audio/mp3;base64,"+this.peiyin

          if(!play){
            callback()
            return
          }

          if(this.$refs.py.readyState != 4){
            this.$refs.py.oncanplay =()=>{
                this.$refs.py.play()
                this.bofang = true
            }
          }else{
            this.$refs.py.play()
            this.bofang = true
          }

        }else{
          this.tip(res.data.msg)
        }

      }).catch((err) => {
        loading.close();
        this.tip(err)
        console.log(err);
      });

    },

    changeinput(val){
      
      this.cg = true
    },
    bf_pause(){
      this.bofang=false;
    },
    makeVideo(){
      if(!this.checkUser()){
        return;
      }
      if(this.textarea.length <= 100){
        this.$alert('推文内容太短，无法生成', '操作失败', {
          confirmButtonText: '确定'
          
        });
        return;
      }

      this.axios({
        method: "post",
        url: "/api/tts/tuiwen",
        data: {
          "text":this.textarea,
          "anchor":this.defaultItem.id,
          "speed":this.speedNum,
          "conf":this.conf
        },
      }).then((res) => {
        if(res.data.code == 200){
          this.$alert('提交任务成功，任务已排队剪辑中，大概需求几分钟时间', '操作失败', {
            confirmButtonText: '确定',
            callback: action => {
              window.location.href="/#/workspace"
            }
          });
          
        }else{
          this.$alert(res.data.msg, '操作失败')
        }

      })


    },
    checkUser(){
      return true;
      let userInfo = this.$store.getters.getUserInfo;
      console.log(userInfo)
      if(userInfo.vip_end){
        return true;
      }else{
        this.$alert('本功能内测中，仅限邀请用户使用', '操作失败', {
          confirmButtonText: '确定'
          
        });

        return false;
      }

    },
    subtitles_color(){

    }
  }
}
</script>